import { useState, useCallback, useEffect } from 'react';

type VolatilityDropdownOptionsProps = {
  value: string;
  label: string;
  isDefault?: boolean;
};

export const useVolatilityDropdownOptions = (
  setVolatilityOptions: any,
  key: string,
  initialItems: VolatilityDropdownOptionsProps[] | string = [],
) => {
  const [selectedItems, setSelectedItems] = useState<VolatilityDropdownOptionsProps[] | string>(
    initialItems,
  );

  const handleChange = useCallback(
    (options: VolatilityDropdownOptionsProps[] | string) => {
      if (typeof options === 'string') {
        setSelectedItems(options);
        setVolatilityOptions((state: any) => ({ ...state, [key]: options }));
      } else {
        const mappedOptions = options.map((option) => option.value).sort();
        if (Array?.isArray(mappedOptions[0]) && mappedOptions[0]?.length > 0) {
          setSelectedItems(options);
          setVolatilityOptions((state: any) => ({ ...state, [key]: options[0] }));
          return;
        }

        setSelectedItems(options);
        setVolatilityOptions((state: any) => ({ ...state, [key]: mappedOptions }));
      }
    },
    [setVolatilityOptions, key],
  );

  useEffect(() => {
    if (Array.isArray(initialItems) && initialItems.length > 0) {
      handleChange(initialItems);
    } else if (typeof initialItems === 'string') {
      handleChange(initialItems);
    }
  }, [initialItems, handleChange]);

  return {
    selectedItems,
    handleChange,
  };
};
